import { Link } from "react-router-dom";
import { Flame, ArrowLeft } from "lucide-react";

export default function Termos() {
  return (
    <div className="min-h-screen bg-[#090D16] text-slate-100 px-4 sm:px-6 py-12" data-testid="termos-page">
      <div className="max-w-3xl mx-auto">
        <Link to="/" className="inline-flex items-center gap-2 text-sm text-emerald-400 hover:text-emerald-300 mb-8">
          <ArrowLeft className="w-4 h-4" /> Voltar para o início
        </Link>
        <div className="flex items-center gap-2.5 mb-6">
          <Flame className="w-6 h-6 text-emerald-400" />
          <span className="font-heading font-extrabold text-xl">MaturaMax</span>
        </div>
        <h1 className="font-heading text-3xl font-bold tracking-tight mb-6">Termos de Uso</h1>
        <div className="space-y-4 text-sm text-slate-400 leading-relaxed">
          <p>O MaturaMax é uma plataforma de aquecimento (maturação) de chips WhatsApp que simula comportamento humano legítimo por meio de conversas automatizadas entre chips, chamadas simuladas e interação em grupos controlados, com o objetivo de blindagem e contingência de números.</p>
          <p>Ao assinar, você concorda em utilizar a plataforma em conformidade com os termos de serviço da Meta. O disparo de mensagens em massa sem autorização (spam) não é suportado pelo nosso motor de loops e pode resultar em suspensão da conta.</p>
          <p>A decisão final de bloqueio ou banimento de um número é exclusiva da Meta. O MaturaMax reduz drasticamente os riscos, mas não garante imunidade absoluta.</p>
          <p>Assinaturas são cobradas mensalmente via InfinitePay (Pix ou cartão no checkout seguro). Não há fidelidade: você pode cancelar ou trocar de plano quando quiser diretamente pelo painel.</p>
          <p>Dúvidas? Fale com a gente em suporte@maturamax.com.br.</p>
        </div>
      </div>
    </div>
  );
}
